import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const useCloseOnRouteChange = (onClose) => {
  const { pathname } = useLocation();
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    onCloseRef.current();
  }, [pathname]);
};

export default useCloseOnRouteChange;
